module.exports = __webpack_public_path__ + "img/icon_account_setting_selected.1c9d0883.svg";